module.exports = __webpack_public_path__ + "img/offers1.471211fb.jpg";